import { useFeedTroughMaintenance } from '@Src/redux/feedTroughMaintenance/feedTroughMaintenanceActions';
import { Box, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import YatungButton from '@Src/_basic/components/YatungButton';
import AddCircleFill from '@Src/_basic/icons/AddCircleFill';
import { WarehouseAndStateData } from '@Src/_basic/object/FeedTroughMaintenanceManagement';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import FeedTroughMaintenanceCreateWindowPaper from './FeedTroughMaintenanceManagementPaper/FeedTroughMaintenanceCreateWindowPaper';

interface Props {
  selectedArea: number;
  selectedFactory: number;
  groupsSize: number;
}
export default function FeedTroughMaintenanceManagementCard(props: Props) {
  const { t: i18T } = useTranslation();
  const { selectedArea, selectedFactory } = props;
  const {
    feedTroughMaintenanceCreateDatas,
    setFeedTroughMaintenanceCreateDatas,
    feedTroughMaintenanceData,
    setFeedTroughMaintenanceMappingDatas,
    feedTroughMaintenanceMappingDatas,
  } = useFeedTroughMaintenance();
  const mappgingData = () => {
    const mappingData = [...feedTroughMaintenanceCreateDatas, ...feedTroughMaintenanceData];
    setFeedTroughMaintenanceMappingDatas(mappingData);
  };
  const handleCreatePage = () => {
    const objectData = {
      id: Math.random(),
      typeId: 0,
      name: '',
      specificationId: 0,
      volume: 0,
      specificWeight: 0,
      state: false,
      code: '',
      factoryId: selectedFactory,
    };
    if (selectedArea !== 0 && selectedFactory !== 0) {
      const newDatas = Object.assign([], feedTroughMaintenanceCreateDatas);
      newDatas.push(objectData);

      setFeedTroughMaintenanceCreateDatas(newDatas);
    }
  };
  useEffect(() => {
    if (feedTroughMaintenanceCreateDatas) {
      mappgingData();
    }
  }, [feedTroughMaintenanceCreateDatas, feedTroughMaintenanceData]);
  useEffect(() => {
    if (selectedFactory > 0) {
      setFeedTroughMaintenanceCreateDatas([]);
    }
  }, [selectedFactory]);
  const actionBarRef = useRef<HTMLDivElement>(null);

  const [mixerMapGroups, setMixerMapGroups] = useState<Array<Array<WarehouseAndStateData>>>([]);
  const [mixerGroupsSize, setMixerGroupsSize] = useState<number>(2);
  const getMixerMapGroup = () => {
    const mixerMapGroupsTemp: Array<Array<WarehouseAndStateData>> = [];
    const totoalMixerMapTemp: Array<WarehouseAndStateData> = [...feedTroughMaintenanceMappingDatas];
    while (totoalMixerMapTemp.length > 0) {
      mixerMapGroupsTemp.push(
        totoalMixerMapTemp.splice(
          0,
          totoalMixerMapTemp.length > mixerGroupsSize ? mixerGroupsSize : totoalMixerMapTemp.length,
        ),
      );
    }

    setMixerMapGroups(mixerMapGroupsTemp);
  };
  useEffect(() => {
    getMixerMapGroup();
  }, [feedTroughMaintenanceMappingDatas]);
  useEffect(() => {
    if (props.groupsSize) {
      setMixerGroupsSize(props.groupsSize);
    }
  }, [props.groupsSize]);
  return (
    <Box
      sx={{
        border: '2px solid #E9E9E9',
        p: 1,
        pt: 2,
        height: '82%',
      }}
    >
      <Stack justifyContent="flex-end" flexDirection="row" sx={{ mb: 0.6 }} ref={actionBarRef}>
        <YatungButton
          text={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.CREATE')}
          startIcon={<AddCircleFill />}
          onClick={handleCreatePage}
          color="green"
          disabled={selectedFactory === 0}
        />
      </Stack>
      <AutoSizer>
        {({ height, width }: { height: number; width: number }) => (
          <FixedSizeList
            height={
              actionBarRef.current
                ? (height as number) - actionBarRef.current.getBoundingClientRect().height
                : (height as number)
            }
            itemData={mixerMapGroups}
            itemCount={mixerMapGroups.length}
            itemSize={560}
            width={width as number}
          >
            {FeedTroughMaintenanceCreateWindowPaper}
          </FixedSizeList>
        )}
      </AutoSizer>
    </Box>
  );
}
